import * as OM from '@/Model';
import { CommonServices } from '@/services/CommonServices';
import { StorageServices } from '@/services/StorageServices';
import { AppUserClient } from './Services';
import store from '@/store';
import router from '@/router';

class _LoginServices {
    
    loginCallback = (baseApiLoginResponseOfLoggedUserVM: OM.BaseApiLoginResponseOfLoggedUserVM) => {
        if (!baseApiLoginResponseOfLoggedUserVM) {
            this.logout()

            return
        }

        const refreshTokenVM: OM.RefreshTokenVM = {
            device: baseApiLoginResponseOfLoggedUserVM.deviceID ? {
                deviceID: baseApiLoginResponseOfLoggedUserVM.deviceID,
                ipAddress: '',
            } : undefined,
            refreshToken: baseApiLoginResponseOfLoggedUserVM.refreshToken,
            refreshTokenExpiryTime: baseApiLoginResponseOfLoggedUserVM.refreshTokenExpiryTime,
            token: baseApiLoginResponseOfLoggedUserVM.token,
        }

        StorageServices.setRefreshTokenVM(refreshTokenVM)
        this.setLoggedUser(baseApiLoginResponseOfLoggedUserVM)

        AppUserClient.refreshToken(refreshTokenVM)
        .then((x) => {
            const refreshTokenVM: OM.RefreshTokenVM = {
                device: x.deviceID ? {
                    deviceID: x.deviceID,
                    ipAddress: '',
                } : undefined,
                refreshToken: x.refreshToken,
                refreshTokenExpiryTime: x.refreshTokenExpiryTime,
                token: x.token,
            }

            StorageServices.setRefreshTokenVM(refreshTokenVM)

            if(router.currentRoute.value.query.redirect){
                router.push(router.currentRoute.value.query.redirect as string);
            } else {
                router.push('/home');
            }
        })
        .catch(() => {
            this.logout()
        })
    }

    logout(){
        let prom = new Promise<void>((resolve, reject) => {
            CommonServices.destroyToken();
            resolve();
        })

        return prom;
    }

    setLoggedUser(baseApiLoginResponseOfLoggedUserVM: OM.BaseApiLoginResponseOfLoggedUserVM) {
        const loggedUser = baseApiLoginResponseOfLoggedUserVM.loggedEntityData
        StorageServices.setLoggedUser(loggedUser)

        store.state.user = loggedUser

        const refreshTokenVM: OM.RefreshTokenVM = {
            device: baseApiLoginResponseOfLoggedUserVM.deviceID ? {
                deviceID: baseApiLoginResponseOfLoggedUserVM.deviceID,
                ipAddress: '',
            } : undefined,
            refreshToken: baseApiLoginResponseOfLoggedUserVM.refreshToken,
            refreshTokenExpiryTime: baseApiLoginResponseOfLoggedUserVM.refreshTokenExpiryTime,
            token: baseApiLoginResponseOfLoggedUserVM.token,
        }

        StorageServices.setRefreshTokenVM(refreshTokenVM)

        store.state.getCanBuyPackages()
        store.state.getUnreadChatCount()
    }

}

export let LoginServices = new _LoginServices();